import { Component, ComponentFactoryResolver, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AspCustomerDetailsService } from './asp-customer-details.service';
import { AspRecordPaymentComponent } from "../asp-record-payment/asp-record-payment.component";
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SideBarJobcardComponent } from '../side-bar-jobcard/side-bar-jobcard.component';

interface FilterOption {
  label: string;
  value: string;
  checked: boolean;
  children?: FilterOption[];
}
interface Filters {
  jobCardStatus: FilterOption[];
}
interface FilterOption {
  label: string;
  value: string;
  checked: boolean;
  children?: FilterOption[];
}

interface Filters1 {
  jobCardStatus: FilterOption[];
}
@Component({
  selector: 'app-asp-customer-details',
  templateUrl: './asp-customer-details.component.html',
  styleUrls: ['./asp-customer-details.component.scss']
})
export class AspCustomerDetailsComponent implements OnInit {
  selectedTab: string = 'jobCard';
  data: any;
  vehicleData: any = [];
  vehicleServiceDetails: any;
  registrationNumbers: string[];
  selectedVehicleKey: any;
  selectedVehicleData: any;
  isJobCardDetails: any;
   selectedRatecardType: string;
  // new: any;
  statusList = [
    {label: 'Reject', value: '0', checked: false,statusclass: 'reject-status'},
    {label: 'Create', value: '1', checked: false,statusclass: 'createStatus'},
    { label: 'Quote Due', value: '2', checked: false, statusclass: 'quote-due'},
    { label: 'Approval Due', value: '3', checked: false, statusclass: 'approval-due'},
    { label: 'In Progress', value: '4', checked: false, statusclass: 'inprogress'},
    { label: 'Ready', value: '5', checked: false, statusclass: 'ready'},
    { label: 'Invoice', value: '6', checked: false, statusclass: 'invoice'},
    { label: 'Close', value: '7', checked: false, statusclass: 'close-status'},
  ];
  filters: Filters = {
    jobCardStatus: this.statusList,
  }
  statusList1 = [
    { label: 'Draft', value: '1', checked: false, statusclass: 'delivered-status'},
    { label: 'Confirmed', value: '2', checked: false, statusclass: 'confirmed-status'},
     ];

  filters1: Filters1 = {
    jobCardStatus: this.statusList1,
  }
  mobileNumber: number;
  id: number;
  isMobile: any;
  customerDetailsResponse: any;
  constructor(private router: Router,
    private bottomSheet: MatBottomSheet,
    private aspCustomerDetailsService:AspCustomerDetailsService,
    private resolver: ComponentFactoryResolver,
    private route:ActivatedRoute,
    private location: Location,
    private aspLoadingService: AspLoadingService,
    private breakpointObserver: BreakpointObserver,
  ) { 
     this.breakpointObserver.observe([Breakpoints.Handset])
        .subscribe(result => {
          this.isMobile = result.matches;
        }); 
  }
 @ViewChild('dynamicContainer', { read: ViewContainerRef }) recordpaymentcontainer!: ViewContainerRef;
 @ViewChild('myButton') myButton!: ElementRef<HTMLButtonElement>;
  @ViewChild('dynamicContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
  selectedIndex = 0;
  
  selectFilter(index): void {
    
    this.selectedIndex = this.registrationNumbers.indexOf(index);
    this.selectedVehicleKey = index;
    this.selectedVehicleData = this.vehicleServiceDetails[index];
    // console.log(" this.selectedVehicleData", this.selectedVehicleData);
    // console.log("this.selectedIndex",this.selectedIndex)
  }
  
  ngOnInit(): void {
    this.mobileNumber = Number(this.route.snapshot.paramMap.get('ph'));
    this.id = Number(this.route.snapshot.paramMap.get('id'));
    this.getCustomerDetails();
  }
  ngOnDestroy(): void {
  if (localStorage.getItem('jobcardFrom') === 'customer') {
    localStorage.removeItem('jobcardFrom');
  }
}

  getCustomerDetails(){  
    this.aspLoadingService.show();
    // const customerId = 34;
    const garageKey = localStorage.getItem('garageKey');
    // const mobileNumber= "1234567890";
    this.aspCustomerDetailsService.getCustomerDetails(garageKey, this.id,this.mobileNumber).subscribe(
      result => {
        this.aspLoadingService.hide();
        const res = JSON.parse(JSON.stringify(result));
        this.data=res.data;
        this.vehicleData = [];
        this.vehicleServiceDetails = res.data.vehicleServiceDetails;
        this.registrationNumbers = Object.keys(this.vehicleServiceDetails).filter(
          key => key !== "outstandingAmount",
          
        );
     
        res.data.vehicleDetails.forEach(vehicle => {
          this.vehicleData[vehicle.registrationNumber] = vehicle;
        });
        if (this.registrationNumbers.length > 0) {
          this.selectedVehicleKey = this.registrationNumbers[0];
          this.selectedVehicleData = this.vehicleServiceDetails[this.selectedVehicleKey];
          this.selectedIndex = 0;
      
          this.selectFilter(this.selectedVehicleKey);
          // console.log("selectedVehicleData",this.selectedVehicleData)
        }
        
});
}
navigateToDetails(id: string,jobcardId,quoteId) {
  this.router.navigate(['/invoice-details'], { queryParams: {"id": id, "jobcardId":jobcardId,"QuoteId":quoteId}})
}

  selectTab(tab: string) {
    this.selectedTab = tab;
  }
openRecordPaymentSidebar(paymentId,jobcardId) {
      const factory = this.resolver.resolveComponentFactory(AspRecordPaymentComponent);
      const componentRef = this.recordpaymentcontainer.createComponent(factory);
      const componentInstance = componentRef.instance as AspRecordPaymentComponent;

      componentInstance.isReceiptSidebarOpen = true;
      componentInstance.openReceiptSidebar();
      componentInstance.jobcardId = jobcardId;
      componentInstance.paymentpopupId = paymentId;
      
      }
      goBack(): void {
        this.location.back();
      }
      //  loadorderdetails(): void {
      //     // console.log('Job card details loaded and sidebar opened.');
      //     this.container.clear();
          
      //     // Dynamically create the component
      //     const factory = this.resolver.resolveComponentFactory(SideBarJobcardComponent);
      //     const componentRef = this.container.createComponent(factory);
          
      //     // Access the component instance
      //     const componentInstance = componentRef.instance as SideBarJobcardComponent;
        
      //     // Toggle the form sidebar (instead of the confirmation sidebar)
      //     if(localStorage.getItem('jobcard')  && localStorage.getItem('jobcard') == '1'){
      //       // this.loadorderdetails();
      
      //     componentInstance.isVisible = false;  // Open form sidebar instead of confirmation sidebar
      //     componentInstance.isConfirmationSidebarOpen = true; // Ensure confirmation sidebar is closed
      //   }
      //   else{
      //     componentInstance.isVisible = true;  // Open form sidebar instead of confirmation sidebar
      //     componentInstance.isConfirmationSidebarOpen = false;
      //   }
      //     // console.log('Form Sidebar component is opened.');
      //   }

loadorderdetails(): void {
  if (!this.data || !this.selectedVehicleKey) {
    console.error('Customer details or selected vehicle not loaded yet.');
    return;
  }

  const customerData = this.data;
  // console.log("this.customer response----",this.data);
  const selectedRegNo = this.selectedVehicleKey;

  const vehicle = customerData.vehicleDetails.find(
    v => v.registrationNumber === selectedRegNo
  );

  if (!vehicle) {
    console.error('Selected vehicle not found in vehicleDetails.');
    return;
  }

  const jobCard = customerData.vehicleServiceDetails?.[selectedRegNo]?.[0]?.jobCardDetails;

  this.container.clear();
  const factory = this.resolver.resolveComponentFactory(SideBarJobcardComponent);
  const componentRef = this.container.createComponent(factory);
  const componentInstance = componentRef.instance as SideBarJobcardComponent;

  // Set jobcard flag in localStorage if you want to track source
  localStorage.setItem('jobcardFrom', 'customer');

  // Pass prefilled data, including GST presence
  componentInstance.prefilledData = {
    customerName: customerData.customerName,
    mobile: customerData.mobile,
    email: customerData.email,
    hasGst: !!customerData.gstNumber && customerData.gstNumber.trim() !== '',
    gstNumber: customerData.gstNumber || '',
    registrationNumber: vehicle.registrationNumber,
    vinNumber: vehicle.vinNumber,
    make: vehicle.make,
    model: vehicle.model,
    variant: vehicle.variant,
    fuelType: vehicle.fuelType,
    year: vehicle.manufactureYear,
    odometer: jobCard?.odometer,
    engineNumber: jobCard?.engineNumber,
    lastServiceDate: jobCard?.lastServiceDate,
    rateCardApplicable: customerData.rateCardApplicable,
  };

  // console.log("prefilled Data---",componentInstance.prefilledData);

    componentInstance.prefilledData.gstDetails = customerData.customerGstDetailsResponse || null,


  // Show the sidebar
  componentInstance.isVisible = true;
  componentInstance.isConfirmationSidebarOpen = true;
}

}
